import httpClient from "./httpClient";
import { ANIMAL_SPLIT_CORE } from "../constants";

const API_BASE_URL = ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL;

export const getDemoTemplate = async () => {
  const response = await httpClient.get(`${API_BASE_URL}/api/v0/jubensha/templates/demo`);
  return response.data;
};

export const createDemoRoom = async ({ name } = {}) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/jubensha/demo-room`, { name });
  return response.data;
};

export const startStory = async (roomId) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/jubensha/${roomId}/start`, {});
  return response.data;
};

export const advanceStage = async (roomId) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/jubensha/${roomId}/advance-stage`, {});
  return response.data;
};

export const selectEnding = async (roomId, endingId) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/jubensha/${roomId}/select-ending`, {
    endingId,
  });
  return response.data;
};

export const claimSeat = async (roomId, seatPosition, playerName) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/room/${roomId}/take-seat`, { seatPosition, playerName });
  return response.data;
};

export const leaveSeat = async (roomId, seatPosition) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/room/${roomId}/leave-seat`, { seatPosition });
  return response.data;
};

export const updateCharacter = async (roomId, seatPosition, payload) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/jubensha/${roomId}/update-character`, {
    seatPosition,
    ...payload,
  });
  return response.data;
};

export const assignItem = async (roomId, seatPosition, itemId) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/jubensha/${roomId}/assign-item`, {
    seatPosition,
    itemId,
  });
  return response.data;
};

export const assignNote = async (roomId, noteId, visibility = 'public', seatPosition = null) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/jubensha/${roomId}/assign-note`, {
    noteId,
    visibility,
    seatPosition,
  });
  return response.data;
};

export const assignTag = async (roomId, seatPosition, tagId) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/jubensha/${roomId}/assign-tag`, {
    seatPosition,
    tagId,
  });
  return response.data;
};

export const claimMapReward = async (roomId, { seatPosition, stageKey, locationId, rewardType, rewardId }) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/jubensha/${roomId}/claim-map-reward`, {
    seatPosition,
    stageKey,
    locationId,
    rewardType,
    rewardId,
  });
  return response.data;
};

export const enterMapLocation = async (roomId, { seatPosition, stageKey, locationId }) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/jubensha/${roomId}/enter-map-location`, {
    seatPosition,
    stageKey,
    locationId,
  });
  return response.data;
};

export const moveItemToSlot = async (roomId, seatPosition, itemId, slotId) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/jubensha/${roomId}/move-item-to-slot`, {
    seatPosition,
    itemId,
    slotId,
  });
  return response.data;
};

export const moveItemToInventory = async (roomId, seatPosition, slotId) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/jubensha/${roomId}/move-item-to-inventory`, {
    seatPosition,
    slotId,
  });
  return response.data;
};

export const removeItem = async (roomId, seatPosition, itemId, fromSlot = null) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/jubensha/${roomId}/remove-item`, {
    seatPosition,
    itemId,
    fromSlot,
  });
  return response.data;
};
